import { Text } from "recharts";

type TChartsCustomXAxisTick = ((props: any) => React.ReactElement<SVGElement>);

const ChartsCustomXAxisTick: TChartsCustomXAxisTick = (props) => {
  const { t, labelWidth, x, y, stroke, payload } = props;
  const color = stroke || "#666666";
  const fontSize = '8px';
  const text = !!t ? t(payload.value) : payload.value;
  return (
    <switch>
      {/* height="200" */}
      <foreignObject x={x - (labelWidth ?? 80) / 2} y={y} width={labelWidth ?? 80} height={24} textAnchor="middle" >
        <p style={{ color, fontSize, lineHeight: '1em', textAlign: 'center', width: `${labelWidth ?? 80}px`, wordBreak: text.toString().indexOf(' ') > -1 ? "break-word" : "break-all" }}>
          {text}
        </p>
      </foreignObject>
      <Text
        x={x} y={y + 2}
        style={{ fontSize }}
        fill={color}
        textAnchor="middle"
        width={labelWidth ?? 80}
        verticalAnchor="start"
      >
        {text}
        {/* This is a long tail text just to check if the text actually wraps to the next line or not */}
      </Text>
    </switch>
  )
}
export default ChartsCustomXAxisTick;